var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Success"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6 7.99999C1.6 4.46537 4.46538 1.59999 8 1.59999C11.5346 1.59999 14.4 4.46537 14.4 7.99999C14.4 11.5346 11.5346 14.4 8 14.4C4.46538 14.4 1.6 11.5346 1.6 7.99999ZM10.8854 7.1194C11.1794 6.82536 11.1794 6.34862 10.8854 6.05458C10.5913 5.76054 10.1146 5.76054 9.82053 6.05458L7.21569 8.65942L6.17947 7.6232C5.88543 7.32916 5.40869 7.32916 5.11465 7.6232C4.82061 7.91725 4.82061 8.39398 5.11465 8.68802L6.68328 10.2567C6.97732 10.5507 7.45405 10.5507 7.7481 10.2567L10.8854 7.1194Z",
    fill: "#3AAD2C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccess);
export default __webpack_public_path__ + "static/media/ToastSuccess.4d4d204d0e0aec9b2ff765eb34ce6a30.svg";
export { ForwardRef as ReactComponent };